import { Suspense, useMemo } from 'react';

import { Group, ScrollArea } from '@mantine/core';

import * as Sentry from '@sentry/react';
import { Outlet, matchPath, useLocation } from 'react-router-dom';

import { Error } from '../../../shared/components/UI/Error/Error';
import { Loader } from '../../../shared/components/UI/Loader/Loader';
import { NAVBAR_HEIGHT } from '../../../shared/components/UI/Navbar/Navbar';

import { SideBar } from './sidebar/SideBar';

export function BidResponsePageLayout() {
  const { pathname } = useLocation();
  const isBackground1 = useMemo(() => {
    const isNewAssistant = matchPath('response/assistant', pathname);
    const isNewSearch = matchPath('response/search/new', pathname);

    return isNewAssistant || isNewSearch;
  }, [pathname]);

  return (
    <Group
      noWrap
      h="100%"
      w="100vw"
      align="flex-start"
      spacing={0}
      sx={theme => ({
        background: isBackground1
          ? theme.other.gradients.background1
          : theme.other.gradients.background2,
      })}
    >
      <SideBar />

      <Sentry.ErrorBoundary fallback={<Error />}>
        <Suspense fallback={<Loader />}>
          <ScrollArea h={`calc(100vh - ${NAVBAR_HEIGHT}px)`} w="100%">
            <Outlet />
          </ScrollArea>
        </Suspense>
      </Sentry.ErrorBoundary>
    </Group>
  );
}
